import { useState, useEffect } from "react";

const PRACTITIONERS = [
  {
    id: "dr-boz",
    name: "Dr. Boz",
    fullName: "Dr. Annette Bosworth, MD",
    title: "Internal Medicine · Metabolic Health Educator",
    location: "Sioux Falls, SD",
    bio: "Best-selling author of KetoCONTINUUM and Anyway You Can. 500K+ YouTube subscribers helping patients reverse chronic disease through ketogenic and metabolic protocols.",
    photo: "/dr-boz.jpg",
  },
  {
    id: "dr-berg",
    name: "Dr. Berg",
    fullName: "Dr. Eric Berg, DC",
    title: "Health Educator · Ketogenic & Fasting Expert",
    location: "Alexandria, VA",
    bio: "One of the most followed health educators in the world, teaching millions on ketogenic nutrition, intermittent fasting, and root-cause medicine.",
    photo: "https://customer-assets-lqy194kg.emergentagent.net/job_luxe-med-spa/artifacts/78twe5qi_IMG_1966.jpeg",
  },
  {
    id: "rachel-varga",
    name: "Rachel Varga",
    fullName: "Rachel Varga, BScN, RN, CANS",
    title: "Double Board-Certified Aesthetic Nurse Specialist · Founder, The School of Radiance",
    location: "Sidney, BC",
    bio: "20,000+ aesthetic procedures performed. International clinical educator, celebrity skin expert, and host of the top-20 Rachel Varga Podcast.",
    photo: "https://customer-assets-lqy194kg.emergentagent.net/job_luxe-med-spa/artifacts/j1n0rkdf_IMG_1965.jpeg",
  },
  {
    id: "alexandria-noel",
    name: "Alexandria Noel",
    fullName: "Alexandria Noel",
    title: "Nutrition & Wellness Educator",
    location: "United States",
    bio: "Founder of Real Food by Lexi and Divine Eats. 170K+ community focused on real food, faith, strength training, and holistic recovery.",
    photo: "https://customer-assets-lqy194kg.emergentagent.net/job_luxe-med-spa/artifacts/awqx59vf_IMG_1968.jpeg",
  },
  {
    id: "the-source",
    name: "The Source",
    fullName: "The Source Wellness",
    title: "Integrative Wellness Clinic",
    location: "Multi-location, USA",
    bio: "A leading integrative wellness clinic network integrating IV therapy, red light, hyperbaric, and vibration recovery into modern longevity protocols.",
    photo: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&q=85",
  },
];

export default function WhoUsesTheraTec() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const p = PRACTITIONERS[active];

  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => {
      setActive((i) => (i + 1) % PRACTITIONERS.length);
    }, 6000);
    return () => clearInterval(t);
  }, [paused]);

  return (
    <section
      data-testid="who-uses-theratec"
      className="bg-[#F5F3EE] py-8 sm:py-10 lg:py-14"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="max-w-[1100px] mx-auto px-5 sm:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-3 mb-5 sm:mb-6">
          <div className="max-w-xl">
            <div className="overline">Who Uses TheraTec</div>
            <h2 className="font-serif-editorial text-lg sm:text-xl lg:text-2xl mt-2 leading-snug">
              Used by some of the top{" "}
              <em className="italic">doctors and clinics in the US.</em>
            </h2>
            <p
              data-testid="who-uses-stat"
              className="mt-3 text-xs sm:text-sm text-[#1C1C1C] leading-relaxed"
            >
              Our affiliates and doctors combined have a following of{" "}
              <span className="tt-shimmer-gold font-medium">46 million+</span>{" "}
              followers across social medias.
            </p>
          </div>
          <p className="hidden lg:block max-w-xs text-[11px] text-[#5C5C5C] leading-relaxed">
            Trusted daily inside the practices shaping the future of longevity and aesthetic medicine.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-3 lg:gap-4">
          {/* Left: featured card */}
          <div className="lg:col-span-3 relative overflow-hidden border border-[#E5E5E5] bg-[#FAF9F6]">
            <div className="grid grid-cols-[112px_1fr] sm:grid-cols-[140px_1fr] md:grid-cols-2">
              <div className="aspect-[3/4] sm:aspect-[4/5] md:aspect-auto md:min-h-[240px] overflow-hidden bg-[#F5F3EE]">
                <img
                  key={p.id}
                  src={p.photo}
                  alt={p.fullName}
                  data-testid={`practitioner-photo-${p.id}`}
                  className="w-full h-full object-cover"
                  style={{ objectPosition: "50% 35%", animation: "tt-fade-up 700ms ease both" }}
                />
              </div>
              <div className="p-3 sm:p-4 md:p-4 flex flex-col justify-between min-w-0" key={p.id + "-copy"} style={{ animation: "tt-fade-up 700ms ease both" }}>
                <div>
                  <div className="overline">Used by</div>
                  <h3 className="font-serif-editorial text-base sm:text-lg md:text-lg lg:text-xl mt-1 leading-tight">{p.name}</h3>
                  <div className="mt-1.5 text-[11px] sm:text-xs md:text-[11px] font-medium">{p.fullName}</div>
                  <div className="mt-0.5 text-[11px] sm:text-xs md:text-[11px] text-[#5C5C5C] leading-tight line-clamp-2">{p.title}</div>
                  <div className="mt-1 md:mt-0.5 overline">{p.location}</div>
                  <p className="hidden sm:block mt-2 text-xs leading-relaxed text-[#1C1C1C]/85 line-clamp-3">{p.bio}</p>
                </div>
                <div className="mt-2 sm:mt-3 md:mt-3 pt-2 sm:pt-3 md:pt-2 border-t border-[#E5E5E5] flex items-center justify-between">
                  <div className="overline text-[10px]">
                    {String(active + 1).padStart(2, "0")} / {String(PRACTITIONERS.length).padStart(2, "0")}
                  </div>
                  <div className="flex gap-1.5">
                    <button
                      data-testid="practitioner-prev"
                      onClick={() => setActive((i) => (i - 1 + PRACTITIONERS.length) % PRACTITIONERS.length)}
                      className="w-7 h-7 sm:w-8 sm:h-8 md:w-6 md:h-6 border border-[#1C1C1C] flex items-center justify-center hover:bg-[#1C1C1C] hover:text-[#FAF9F6] active:bg-[#1C1C1C] active:text-[#FAF9F6] transition-colors duration-300 text-xs"
                      aria-label="Previous practitioner"
                    >←</button>
                    <button
                      data-testid="practitioner-next"
                      onClick={() => setActive((i) => (i + 1) % PRACTITIONERS.length)}
                      className="w-7 h-7 sm:w-8 sm:h-8 md:w-6 md:h-6 border border-[#1C1C1C] flex items-center justify-center hover:bg-[#1C1C1C] hover:text-[#FAF9F6] active:bg-[#1C1C1C] active:text-[#FAF9F6] transition-colors duration-300 text-xs"
                      aria-label="Next practitioner"
                    >→</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: list */}
          <div className="lg:col-span-2 flex flex-col mt-1 lg:mt-0">
            {PRACTITIONERS.map((pr, i) => (
              <button
                key={pr.id}
                data-testid={`practitioner-tab-${pr.id}`}
                onClick={() => setActive(i)}
                className={`text-left border-t border-[#E5E5E5] py-3 md:py-2 px-3 md:px-2 flex items-center gap-3 transition-colors duration-300 ${
                  i === active ? "bg-[#FAF9F6]" : "hover:bg-[#FAF9F6]/60 active:bg-[#FAF9F6]/70"
                } ${i === PRACTITIONERS.length - 1 ? "border-b" : ""}`}
              >
                <div className={`w-9 h-9 md:w-7 md:h-7 rounded-full overflow-hidden flex-shrink-0 grayscale transition-all duration-500 ${i === active ? "ring-1 ring-[#1C1C1C] ring-offset-2 ring-offset-[#FAF9F6]" : "opacity-70"}`}>
                  <img src={pr.photo} alt="" className="w-full h-full object-cover" style={{ objectPosition: "50% 25%" }} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-serif-editorial text-base md:text-sm leading-tight truncate">{pr.name}</div>
                  <div className="text-[11px] md:text-[10px] text-[#5C5C5C] mt-0.5 truncate">{pr.title}</div>
                </div>
                <div className={`w-3 h-px transition-all duration-500 shrink-0 ${i === active ? "bg-[#1C1C1C] w-6" : "bg-[#A8A096]"}`} />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
